<template>
  <div v-if="this.state === 'question'">
    Pots are: <a @click.prevent="wrongAnswer()" href="#">permanent</a> or <a @click.prevent="rightAnswer()" href="#">impermanent</a>?
  </div>
  <div v-else-if="this.state === 'correct-answer'">
    <a href="mailto:a.hughes@maitripa.org?subject=pum-ba-mi-dak-ba.site%3A%20feedback&body=">a.hughes@maitripa.org</a>
  </div>
  <div v-else-if="this.state === 'wrong-answer'">
    <a @click.prevent="doShowQuestion()" href="#">Wrong! You are doomed to cyclic existence forever!</a>
  </div>
  <div v-else>
    <a @click.prevent="doShowQuestion()" href="#">Would you like to email me?</a>
  </div>
</template>

<script>
export default {
  name: 'EmailQuestion',
  props: {
    email: String
  },
  data() {
    return {
      state: 'start',
    }
  },
  methods: {
    doShowQuestion() {
      this.state = 'question'
    },
    rightAnswer() {
      this.state = 'correct-answer'
    },
    wrongAnswer() {
      this.state = 'wrong-answer'
    },
    getEmailText() {
      return this.showEmail ? '<a href="mailto:a.hughes@maitripa.org?subject=pum-ba-mi-dak-ba.site%3A%20feedback&body="\n>a.hughes@maitripa.org</a>' : "Would you like to email me?"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
